import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../GRI300/GRI308/SectionHeading";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GRI406 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    statusActions: {
      discriminationIncidentStatusActions: "",
      incidentReviewed: "",
      remediationPlansImplemented: "",
      remediationPlansDetails: "",
      noLongerSubject: "",
    },

    incidentsOfDiscrimination: {
      number: "",
      remark: "",
    },
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        const data = response.data.data.GRI400?.nonDiscrimination || {};
        setFormData({
          statusActions: {
            discriminationIncidentStatusActions:
              data.statusActions?.discriminationIncidentStatusActions || "",
            remediationPlansImplemented:
              data.statusActions?.remediationPlansImplemented || "",
            incidentReviewed: data.statusActions?.incidentReviewed || "",
            remediationPlansDetails:
              data.statusActions?.remediationPlansDetails || "",
            noLongerSubject: data.statusActions?.noLongerSubject || "",
          },
          incidentsOfDiscrimination: {
            number: data.incidentsOfDiscrimination?.number || "",
            remark: data.incidentsOfDiscrimination?.remark || "",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData
    // if (!formData.statusActions.discriminationIncidentStatusActions) {
    //   newErrors.discriminationIncidentStatusActions = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.statusActions.incidentReviewed) {
    //   newErrors.incidentReviewed = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.statusActions.remediationPlansImplemented) {
    //   newErrors.remediationPlansImplemented = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.statusActions.remediationPlansDetails) {
    //   newErrors.remediationPlansDetails = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.statusActions.noLongerSubject) {
    //   newErrors.noLongerSubject = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.incidentsOfDiscrimination.number) {
    //   newErrors.number = "This field is required";
    //   formIsValid = false;
    // } else

    if (isNaN(formData.incidentsOfDiscrimination.number)) {
      newErrors.number = "Please enter a valid numeric value";
      formIsValid = false;
    } else if (formData.incidentsOfDiscrimination.number < 0) {
      newErrors.number = "Please enter a valid numeric value";
      formIsValid = false;
    }

    // if (!formData.incidentsOfDiscrimination.remark) {
    //   newErrors.remark = "This field is required";
    //   formIsValid = false;
    // }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission

      const payload = {
        type: "GRI400",
        submitted406: true,
        nonDiscrimination: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/407-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/407-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <p className={styles.section_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>406 : Non Discrimination</p>
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        406-1 : Incidents of discrimination and corrective actions taken
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <SectionHeading text="a. Indicate number of incidents of discrimination occurred during the reporting period?" />
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "20%" }}>
            <CustomTextField
              value={formData.incidentsOfDiscrimination.number}
              onChange={(e) =>
                handleNestedInputChange(
                  "incidentsOfDiscrimination",
                  "number",
                  e.target.value
                )
              }
              error={errors.number}
              placeholder={"No. of Incidents"}
              helperText={errors.number}
              disabled={disabled}
            />
          </Box>

          <Box sx={{ width: "80%" }}>
            <CustomTextField
              value={formData.incidentsOfDiscrimination.remark}
              onChange={(e) =>
                handleNestedInputChange(
                  "incidentsOfDiscrimination",
                  "remark",
                  e.target.value
                )
              }
              error={errors.remark}
              helperText={errors.remark}
              disabled={disabled}
            />
          </Box>
        </Box>

        <SectionHeading text="b. What is the current status of the discrimination incidents, and what actions have been taken? Please indicate:" />
        <CustomTextField
          value={formData.statusActions.discriminationIncidentStatusActions}
          onChange={(e) =>
            handleNestedInputChange(
              "statusActions",
              "discriminationIncidentStatusActions",
              e.target.value
            )
          }
          error={errors.discriminationIncidentStatusActions}
          helperText={errors.discriminationIncidentStatusActions}
          disabled={disabled}
        />

        <Box sx={{ marginLeft: "1rem" }}>
          <SectionHeading text="i. Whether the incident has been reviewed by the organization." />
          <CustomTextField
            value={formData.statusActions.incidentReviewed}
            onChange={(e) =>
              handleNestedInputChange(
                "statusActions",
                "incidentReviewed",
                e.target.value
              )
            }
            error={errors.incidentReviewed}
            helperText={errors.incidentReviewed}
            disabled={disabled}
          />

          <SectionHeading text="ii. If remediation plans are being implemented." />
          <CustomTextField
            value={formData.statusActions.remediationPlansImplemented}
            onChange={(e) =>
              handleNestedInputChange(
                "statusActions",
                "remediationPlansImplemented",
                e.target.value
              )
            }
            error={errors.remediationPlansImplemented}
            helperText={errors.remediationPlansImplemented}
            disabled={disabled}
          />

          <SectionHeading text="iii. Whether remediation plans have been implemented, and if so, provide details of the results reviewed through routine internal management review processes." />
          <CustomTextField
            value={formData.statusActions.remediationPlansDetails}
            onChange={(e) =>
              handleNestedInputChange(
                "statusActions",
                "remediationPlansDetails",
                e.target.value
              )
            }
            error={errors.remediationPlansDetails}
            helperText={errors.remediationPlansDetails}
            disabled={disabled}
          />

          <SectionHeading text="iv. If the incident is no longer subject to action." />
          <CustomTextField
            value={formData.statusActions.noLongerSubject}
            onChange={(e) =>
              handleNestedInputChange(
                "statusActions",
                "noLongerSubject",
                e.target.value
              )
            }
            error={errors.noLongerSubject}
            helperText={errors.noLongerSubject}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI406;
